import type { EventBus } from '@goodhabitz/learning-activity-communication';

export enum GhccRequestSuffix {
  GetResults = 'getresults',
  StartActivity = 'startactivity',
  Sso = 'sso',
}

export enum GhccPlayerEventCode {
  RatedClose = 106,
  RatedNext = 104,
  RatedAutoNext = 102,
  NotRatedClose = 105,
  NotRatedNext = 103,
  NotRatedAutoNext = 101,
}

export type GhccSession = {
  isInitialized: boolean;
  linkSpeed: number;
  sessionId?: string;
  passportId?: string;
  ssoUrl?: string;
};

export type GhccActivityState = {
  activityId?: string;
  startedTimespan: number;
};

export type GhccState = {
  ghccActivity?: GhccActivityState | null;
  ghccSession: GhccSession;
  eventBus?: EventBus;
  isFetching: boolean;
  iframeElement?: HTMLIFrameElement | null;
  previousActivityId?: string;
};
